import { makeStyles } from '@fluentui/react-components';

export const useHorizontalLineStyles = makeStyles({
    lineBreak: {
        color: 'black',
        opacity: '50%',
        width: '100%'
    }
});
